<template>
    <div name="Barocare-b2c-pc" class="pc-barocare-b2c">
        <BarocareB2cHeader />
        <BarocareB2cHome />
        <BarocareB2cServiceIntro />
        <BarocareB2cServiceUse />
        <BarocareB2cCaution />
        <BarocareB2cInquiry />
        <BarocareB2cFooter />
        <!-- <BarocareB2cPopup /> -->
    </div>
</template>

<script>
import BarocareB2cHeader from '@/components/pc_barocare_b2c/BarocareB2cHeader';
import BarocareB2cHome from '@/components/pc_barocare_b2c/BarocareB2cHome';
import BarocareB2cServiceIntro from '@/components/pc_barocare_b2c/BarocareB2cServiceIntro';
import BarocareB2cServiceUse from '@/components/pc_barocare_b2c/BarocareB2cServiceUse';
import BarocareB2cCaution from '@/components/pc_barocare_b2c/BarocareB2cCaution';
import BarocareB2cInquiry from '@/components/pc_barocare_b2c/BarocareB2cInquiry';
import BarocareB2cFooter from '@/components/pc_barocare_b2c/BarocareB2cFooter';
// import BarocareB2cPopup from '@/components/pc_barocare_b2c/BarocareB2cPopup';

export default {
    name: 'BarocareB2cPc',
    components: {
        BarocareB2cHeader,
        BarocareB2cHome,
        BarocareB2cServiceIntro,
        BarocareB2cServiceUse,
        BarocareB2cCaution,
        BarocareB2cInquiry,
        BarocareB2cFooter,
        // BarocareB2cPopup,
    },
    mounted: function(){
        $('html').animate({
            scrollTop: 0
        }, 300)
    }
}
</script>

<style lang="scss">
@import "../styles/PcBarocareB2c.scss";
</style>


// WEBPACK FOOTER //
// src/page/Pcbarocareb2c.vue